// @flow
import { get } from 'lodash';
import type { Driver } from '../types/Driver';

export const isElectric = (driver: Driver): boolean =>
  ['ENV', 'ECA', 'EAV', 'PAX', 'RED', 'PAR'].includes(
    get(driver, 'vehicleTypeCode')
  );
